import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';

Vue.use(Router);
Vue.use(Meta);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  strict: true,
  scrollBehavior(to, from) {
    if (to.name !== from.name) return { x: 0, y: 0 };
    return false;
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/HomeView.vue'),
    },

    {
      path: '/apps',
      name: 'search',
      component: () => import('@/views/SearchView.vue'),
      props: true,
      meta: {
        isFooterHidden: true,
      },
    },

    {
      path: '/awsdx',
      name: 'aws-search',
      component: () => import('@/views/AwsSearchView.vue'),
      props: true,
      meta: {
        isFooterHidden: true,
      },
    },

    {
      path: '/:appType/:appName/:tab?',
      name: 'app-detail',
      component: () => import('@/views/AppDetailView.vue'),
      props: true,
    },

    {
      path: '*',
      redirect: '/',
    },
  ],
});
